export enum FooterState {
  expanded = 'expanded',
  collapsed = 'collapsed',
}
